var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen flex bg-white"},[_c('sidebar',{staticClass:"flex-none"}),_c('div',{staticClass:"flex-grow min-w-0"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }